import { isDefined } from './util';
import type React from 'react';

export const reactSelectStyles: {
  [key: string]: (provided: React.CSSProperties) => React.CSSProperties;
} = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '32px',
    borderRadius: 0,
    borderColor: '#BDC6D1',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: 'small',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '30px',
    alignContent: 'center',
    fontSize: 'small',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '5px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '5px',
    zIndex: 100,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

export const restrictionsAttributesSelectStyles: Record<
  string,
  (provided: React.CSSProperties) => React.CSSProperties
> = {
  ...reactSelectStyles,
  valueContainer: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
};

export const nodesToOptions = <T extends { id: number; name?: string | null }>(
  nodes: Array<T | null>,
): Array<{ value: T['id']; label: string }> =>
  nodes.filter(isDefined).map((node) => ({
    value: node.id,
    label: node.name || '',
  }));

export const paymentUnitsToOptions = <
  T extends { name: string; value: string },
>(
  paymentUnits: Array<T>,
): Array<T & { id: string }> =>
  paymentUnits.map((paymentUnit) => ({
    ...paymentUnit,
    id: paymentUnit.value,
  }));
